<template>
  <div class="absolute z-50 mis-3 mbs-3">
    <ion-back-button
      :text="''"
      class="translucent text-white rounded-full"
      :default-href="defaultHref"
    />
  </div>
</template>

<script setup lang="ts">
import { IonBackButton } from '@ionic/vue'

defineProps<{
  defaultHref: string | undefined;
}>()
</script>

<style scoped>
ion-back-button.translucent {
  --width: 2rem;
  --icon-font-size: 1.25rem;
  --background: rgba(0,0,0,0.5);
  --padding-end: 0;
  --padding-start: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --icon-padding-bottom: 0;
  --icon-margin-start: 0;
  --icon-margin-end: 0;
  width: var(--width);
  height: var(--width);
  min-height: var(--width);
  min-width: var(--width);
  border-radius: 100%;
  overflow: hidden;
}

.plt-ios ion-back-button.translucent {
  --icon-padding-end: 0.1rem;
}
</style>
